// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pos-dropdown-wrapper {
  position: relative;
  display: block;
  width: 100%;
}

.pos-custom-dropdown {
  cursor: pointer;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.custom-dropdown-arrow {
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
}

.dropdown-menu {
  position: fixed;
  z-index: 9999;
  background-color: white;
  border: 1px solid #ccc;
  min-width: 160px;
  max-height: 240px;
  overflow-y: auto;
  border-radius: 0.5rem;
  margin-top: 0.2rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.dropdown-menu-upward {
  position: absolute;
  bottom: 100%;
  top: auto;
  left: 0;
  z-index: 99;
  background-color: white;
  border: 1px solid #ccc;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0.5rem;
  margin-bottom: 0.2rem;
}

.dropdown-item,
.dropdown-group-label {
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: var(--surface-g3);
  font-size: 0.813rem;
  font-weight: 600;
}

.dropdown-item:hover,
.dropdown-group-label:hover {
  background-color: #f0f0f0;
}

.dropdown-group-label {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.dropdown-submenu {
  padding-left: 1.5rem;
}

.dropdown-item.disabled {
  color: #999;
  cursor: not-allowed;
}

.highlighted {
  background-color: var(--surface-g1);
}

/* For rolling text */
.rolling-text-wrapper {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.rolling-text {
  display: inline-flex;
  white-space: nowrap;
  gap: 2rem;
  animation: marquee 10s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* ── Dark theme ── */
.dark .pos-custom-dropdown {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .dropdown-menu,
.dark .dropdown-menu-upward {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .dropdown-item,
.dark .dropdown-group-label {
  color: #f1f5f9;
}

.dark .dropdown-item:hover,
.dark .dropdown-group-label:hover {
  background-color: #334155;
}

.dark .dropdown-item.disabled {
  color: #475569;
}

.dark .highlighted {
  background-color: #334155;
}`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomDropdown/PosCustomDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".pos-dropdown-wrapper {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.pos-custom-dropdown {\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.custom-dropdown-arrow {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 0.5rem;\n}\n\n.dropdown-menu {\n  position: fixed;\n  z-index: 9999;\n  background-color: white;\n  border: 1px solid #ccc;\n  min-width: 160px;\n  max-height: 240px;\n  overflow-y: auto;\n  border-radius: 0.5rem;\n  margin-top: 0.2rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.dropdown-menu-upward {\n  position: absolute;\n  bottom: 100%;\n  top: auto;\n  left: 0;\n  z-index: 99;\n  background-color: white;\n  border: 1px solid #ccc;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  border-radius: 0.5rem;\n  margin-bottom: 0.2rem;\n}\n\n.dropdown-item,\n.dropdown-group-label {\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  color: var(--surface-g3);\n  font-size: 0.813rem;\n  font-weight: 600;\n}\n\n.dropdown-item:hover,\n.dropdown-group-label:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-group-label {\n  display: flex;\n  gap: 0.25rem;\n  align-items: center;\n}\n\n.dropdown-submenu {\n  padding-left: 1.5rem;\n}\n\n.dropdown-item.disabled {\n  color: #999;\n  cursor: not-allowed;\n}\n\n.highlighted {\n  background-color: var(--surface-g1);\n}\n\n/* For rolling text */\n.rolling-text-wrapper {\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.rolling-text {\n  display: inline-flex;\n  white-space: nowrap;\n  gap: 2rem;\n  animation: marquee 10s linear infinite;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* ── Dark theme ── */\n.dark .pos-custom-dropdown {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .dropdown-menu,\n.dark .dropdown-menu-upward {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .dropdown-item,\n.dark .dropdown-group-label {\n  color: #f1f5f9;\n}\n\n.dark .dropdown-item:hover,\n.dark .dropdown-group-label:hover {\n  background-color: #334155;\n}\n\n.dark .dropdown-item.disabled {\n  color: #475569;\n}\n\n.dark .highlighted {\n  background-color: #334155;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
